import axiosClient from "../axios";
import { ResultDataModel } from "../../utility/interface/api/result-data";
import { SignUpUserBlobInterface } from "../../utility/interface/api/users/sign-up-user-res";
import {
  updateBlobReq,
  despositBalanceBlobReq,
  deductBalanceBlobReq,
} from "../../utility/interface/user";

// login

export const loginGoogleUser = (access_token: string, email: string) => {
  const url = `/loginGoogleUser`;
  const body = {
    access_token,
    email,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

// signup

export const signupUser = (signupBlob: SignUpUserBlobInterface) => {
  const url = `users`;
  const body = {
    ...signupBlob,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

// get user list

export const getUsers = (page: number, page_size: number) => {
  const url = `users?page=${page}&page_size=${page_size}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

// update specific user Status
// status = active/inactive/blocked
export const updateStatus = (user_id: string, status: string) => {
  const url = `users/${user_id}/status`;
  const body = {
    status,
  };
  return axiosClient.put<ResultDataModel<any>>(url, body);
};

// get specific user

export const getUser = (user_id: string) => {
  const url = `users/${user_id}}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

export const updateUserPass = (
  updateBlob: updateBlobReq
) => {
  const url = `auth/password/change`;
  const body = {
    ...updateBlob,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

// update user info or password
export const updateUser = (
  user_id: string,
  update_type: string,
  updateBlob: updateBlobReq
) => {
  const url = `users/${user_id}?update_type=${update_type}`;
  const body = {
    ...updateBlob,
  };
  return axiosClient.put<ResultDataModel<any>>(url, body);
};

// delete specific user
export const deleteUser = (user_id: string) => {
  const url = `users/${user_id}}`;
  return axiosClient.delete<ResultDataModel<any>>(url);
};


export const getRentalHistory = (page: number, page_size: number) => {
  const url = `rentals?page=${page}&page_size=${page_size}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

// POST /users/balance/deduct	Balance Deducted

export const getDeductedBalance = (balance: deductBalanceBlobReq) => {
  const url = `users/balance/deduct`;
  const body = {
    ...balance,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};


export const getBillingsHistory = (page?: number, page_size?: number) => {
  const url = `billings?page=${page}&page_size=${page_size}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

// POST/users/balance/deposit	Balance Deposited

export const depositBalance = (balance: despositBalanceBlobReq) => {
  const url = `users/balance/deposit`;
  const body = {
    ...balance,
  };
  return axiosClient.post<ResultDataModel<any>>(url, body);
};

// GET/users/balance/deposits	Deposit Balance History

export const getDepositBalanceHistory = (
  start_time?: string,
  end_time?: string
) => {
  const url = `users/balance/deposits?start_time=${start_time}&end_time=${end_time}`;
  return axiosClient.get<ResultDataModel<any>>(url);
};

// GET/users/balance/get	Get user balance

export const getUserBalance = () => {
  const url = `users/balance`;
  return axiosClient.get<ResultDataModel<any>>(url);
};
